<div class="preview-gate-overlay d-flex align-items-center justify-content-center"
  role="dialog"
  aria-modal="true"
  aria-labelledby="previewGateTitle">
  <div class="modal-content border-radius-0 preview-gate-card">
    <div class="modal-header text-uppercase py-2 font-size-16">
      <div class="modal-title" id="previewGateTitle">Preview access</div>
    </div>

    <form [formGroup]="gateForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="modal-body">
        <p class="text-color-medium-gray font-size-s mb-3">
          This environment is not public. Please enter the preview credentials to continue.
        </p>

        <div class="form-group">
          <label class="text-color-medium-gray" for="previewGateUsername">
            Username<span class="text-color-mandatory">*</span>:
          </label>
          <input #usernameInput
            id="previewGateUsername"
            type="text"
            class="form-control font-size-s"
            formControlName="username"
            autocomplete="username"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            required
            [attr.aria-invalid]="invalidCredentials || (gateForm.get('username').invalid && gateForm.get('username').touched)"
            [ngClass]="{ 'is-invalid': gateForm.get('username').invalid && gateForm.get('username').touched }">
            @if (gateForm.get('username').invalid && gateForm.get('username').touched) {
              <div class="invalid-feedback"
                >
                Username is required
              </div>
            }
          </div>

          <div class="form-group">
            <label class="text-color-medium-gray" for="previewGatePassword">
              Password<span class="text-color-mandatory">*</span>:
            </label>
            <input id="previewGatePassword"
              type="password"
              class="form-control font-size-s"
              formControlName="password"
              autocomplete="current-password"
              required
              [attr.aria-invalid]="invalidCredentials || (gateForm.get('password').invalid && gateForm.get('password').touched)"
              [ngClass]="{ 'is-invalid': gateForm.get('password').invalid && gateForm.get('password').touched }">
              @if (gateForm.get('password').invalid && gateForm.get('password').touched) {
                <div class="invalid-feedback"
                  >
                  Password is required
                </div>
              }
            </div>

            <div class="font-size-s text-color-mandatory mt-2"
              role="alert"
              aria-live="polite">
              @if (invalidCredentials) {
                Invalid username or password.
              }
              @if (unexpectedError) {
                Credentials cannot be verified in this browser. Please use a secure (https) context.
              }
            </div>
          </div>

          <div class="modal-footer pt-1 border-0">
            <button type="submit"
              class="btn btn-primary btn-lg text-uppercase border-rounded font-weight-normal mx-2"
              [disabled]="checking || gateForm.invalid">
              @if (checking) {
                Checking&hellip;
              } @else {
                Unlock
              }
            </button>
          </div>
        </form>
      </div>
    </div>
